import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { importChouseisan } from '../api'
import { card, input, btnPrimary } from '../lib/ui'

export default function Import() {
  const navigate = useNavigate()
  const [url, setUrl] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const run = async () => {
    setError('')
    if (!url.trim()) return setError('調整さんのURLを入れてください')
    setBusy(true)
    try {
      const { id } = await importChouseisan(url.trim())
      navigate(`/e/${id}`)
    } catch (e) {
      setError(e instanceof Error ? e.message : '取り込みに失敗しました')
      setBusy(false)
    }
  }

  return (
    <div className="animate-in mx-auto max-w-xl px-4 pb-16 pt-5">
      <div className="mb-3 text-sm">
        <a href="/" className="font-medium text-muted transition hover:text-brand">
          ← ヨテピース
        </a>
      </div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-ink">調整さんから取り込む</h1>
      <p className="mb-6 mt-1 text-sm leading-relaxed text-muted">
        調整さんのイベントURLを貼ると、<b className="text-ink">候補日・参加者・出欠（○△✕）</b>をまるごとヨテピースに取り込みます。
      </p>

      <div className={`space-y-3 p-5 ${card}`}>
        <label className="block text-sm font-semibold text-muted">調整さんのURL</label>
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && run()}
          placeholder="https://chouseisan.com/s?h=..."
          className={input}
        />
        {error && (
          <p className="rounded-xl bg-conflict-soft px-4 py-2.5 text-sm font-medium text-conflict">
            {error}
          </p>
        )}
        <button onClick={run} disabled={busy} className={`${btnPrimary} w-full py-3 text-base`}>
          {busy ? '取り込み中…' : '取り込む'}
        </button>
      </div>

      <p className="mt-4 text-xs leading-relaxed text-muted">
        取り込んだ後はヨテピースのイベントとして編集・共有でき、予定のかぶり可視化も使えます。出欠の値は取り込み時点のものです（以降は同期されません）。
      </p>
    </div>
  )
}
